import React from 'react'

const TableName = ({ name }) => {
  return (
    <div className={`w-full py-1.5 px-4 ${name ? "bg-blue" : "bg-blue/40"} text-white font-semibold rounded-lg`} >{name || "Name"}</div>
  )
}

export default TableName